<template>
	<div>
		<el-dialog title="选择文件" :visible.sync="daorudiag" width="700px" :close-on-click-modal="false" append-to-body v-dialogDrag>
			<!-- <minhead :headtitle="daorutitle" :isdiag="true"></minhead> -->
			<div class="Verticalcenter" style="margin-top: 82px;">
				<div class="Centerhorizontally" style="margin-left: 260px;">
					<el-input style="width: 300px;margin-right: 16px;" disabled v-model="upfilename"></el-input>

					<label style="display: flex;align-items: center;">
						<div class="Centerhorizontally bt1">选择文件</div>
						<input type="file" class="sendinput" @change="uploadFile($event)" :value="filestate" />
					</label>
				</div>
			</div>
			<div class="buttomanniu">
				<div class="addstyle"  @click="sureupload">确定</div>
				<!-- <el-button type="primary" @click="sureupload">确定</el-button> -->
				<div class="backstyle"  @click="daorudiag = false">关闭</div>
				<!-- <el-button @click="daorudiag = false">关闭</el-button> -->
			</div>
		</el-dialog>
		<el-dialog title="选择模板" :visible.sync="mbdialog" width="700px" :close-on-click-modal="false" v-dialogDrag>
			<!-- <minhead :headtitle="mbtitle" :isdiag="true"></minhead> -->
			<el-table :data="tableDatatan" border style="width: 95%;margin-left: 2.5%;" @row-click="radiochangenochoose">
				<el-table-column width="55" align="center">
					<template slot-scope="scope">
						<el-radio :label="scope.$index" v-model="radionochoose"></el-radio>
					</template>
				</el-table-column>
				<el-table-column label="模板模式" align="center">
					<template slot-scope="scope">
						<div class="Centerhorizontally">
							<span :style="scope.row.mos == 1 ? 'font-size: 14px;color: #FF8800;margin-right:8px' : 'font-size: 14px;color: #0080FF;margin-right:8px'">
								{{ mostostring(scope.row.mos) }}
							</span>
							<img src="../../../assets/img/chu.png" width="16px" height="16px" v-if="scope.row.mos == 1" />
							<img src="../../../assets/img/ru.png" width="16px" height="16px" v-if="scope.row.mos == 2" />
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="mingc" label="模板名称" align="center"></el-table-column>
				<el-table-column label="创建时间" align="center">
					<template slot-scope="scope">
						<span>{{ formatdate(scope.row.createTime) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="更新时间" align="center">
					<template slot-scope="scope">
						<span>{{ formatdate(scope.row.updateTime) }}</span>
					</template>
				</el-table-column>
			</el-table>
			<div style="margin-top: 18px;padding-bottom: 21px;" class="between-line">
				<div></div>
				<div class="rightbuttom">
					<div class="addstyle" @click="forchoose">确定</div>
					<div class="backstyle" @click="mbdialog = false">取消</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="导入错误信息" :visible.sync="dialogvisibleview" width="600px;" v-dialogDrag>
			<el-input type="textarea" :rows="10" placeholder="" v-model="importErrorLogContent" style="width: 98%;padding: 10px 10px;"></el-input>
		</el-dialog>
		<!-- <minhead :headtitle="headtitle"></minhead> -->
		<div class="areacontent" style="margin-top: 16px;">
			<div class="between-line">
				<div class="Centerupdown">
					<el-dropdown @command="handleCommand" trigger="click" @visible-change="showup" v-permission="Fileimport_FullyElectronic_upload_template" >
						<div class="addstyle" style="width: 99px;margin-right: 24px;">
							<samp>
								上传模板
								<i class="el-icon-arrow-down el-icon--right" v-if="!showstate"></i>
								<i class="el-icon-arrow-up  el-icon--right" v-if="showstate"></i>
							</samp>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="0">标准模板</el-dropdown-item>
							<el-dropdown-item command="1">简易模板</el-dropdown-item>
							<!-- 暂时隐藏<el-dropdown-item command="2">自定义模板</el-dropdown-item> -->
						</el-dropdown-menu>
					</el-dropdown>

					<el-dropdown trigger="click" @visible-change="showup" @command="handleDownloadCommand" v-permission="Fileimport_FullyElectronic_download_template">
						<!-- 	<el-button type="primary" plain split-button style="width: 100px;margin-right: 10px;">
							下载模板
							<i class="el-icon-arrow-down el-icon--right" v-if="!showstate"></i>
							<i class="el-icon-arrow-up  el-icon--right" v-if="showstate"></i>
						</el-button> -->
						<div class="addstyle" style="width: 99px;margin-right: 24px;">
							<samp>
								下载模板
								<i class="el-icon-arrow-down el-icon--right" v-if="!showstate"></i>
								<i class="el-icon-arrow-up  el-icon--right" v-if="showstate"></i>
							</samp>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="-1">标准模板</el-dropdown-item>
							<el-dropdown-item command="0">简易模板</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<div class="addstyle" style="width: 99px;margin-right: 24px;" @click="forrest">
						<samp>
							刷新
							<i class="el-icon-refresh  el-icon--right"></i>
						</samp>
					</div>
					<!-- <el-button type="primary" plain split-button style="width: 100px;margin-right: 10px;" @click="forrest">
						刷新
						<i class="el-icon-refresh  el-icon--right"></i>
					</el-button> -->
				</div>
				<div class="Centerupdown">
					<el-input
						clearable
						style="width: 300px;margin-left: 20px;margin-right: 16px;"
						placeholder="文件名、任务状态、操作人"
						prefix-icon="el-icon-search"
						v-model="serchval"
						@input="forsech"
					></el-input>
				</div>
			</div>
			<div class="areatable">
				<div class="tableh">
					<el-table :data="tableData" ref="multipleTable" border style="width: 100%" height="calc(100vh - 262px )">
						<el-table-column label="文件名" align="left" min-width="160px" show-overflow-tooltip>
							<template slot-scope="scope">
								<span type="text" size="small">{{ scope.row.wenjm }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="zongts" label="导入总条数" align="center" min-width="100px"></el-table-column>
						<el-table-column prop="chenggts" label="成功条数" align="center" min-width="100px"></el-table-column>
						<el-table-column label="失败条数" align="center" min-width="100px">
							<template slot-scope="scope">
								<span :style="scope.row.shibts > 0 ? 'color:red' : ''">{{ scope.row.shibts }}</span>
							</template>
						</el-table-column>
						<el-table-column label="任务状态" align="center" min-width="100px">
							<template slot-scope="scope">
								<div style="display: flex;justify-content: center;">
									<span
										:style="scope.row.zhuangt == '3' ? 'color:red;cursor: pointer;' : scope.row.zhuangt == '2' ? 'color:#00D400' : ''"
										@click="forfile(scope.row)"
									>
										{{ zhuangttostring(scope.row.zhuangt) }}
									</span>
									<el-tooltip class="item" effect="dark" content="点击可查看错误详情" placement="top-start">
										<img src="../../../assets/img/failicon.png" width="10px" height="10px" @click="forfile(scope.row)" v-if="scope.row.zhuangt == '3'" />
									</el-tooltip>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="导入开始时间" align="left" min-width="160px" show-overflow-tooltip>
							<template slot-scope="scope">
								<span>{{ stringtostmp(scope.row.kaissj) }}</span>
							</template>
						</el-table-column>
						<el-table-column label="导入完成时间" align="left" min-width="160px" show-overflow-tooltip>
							<template slot-scope="scope">
								<span>{{ stringtostmp(scope.row.jiessj) }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="caozr" label="操作人" align="center" min-width="100px"></el-table-column>
					</el-table>
				</div>
				<div class="buttompage">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[10, 20, 100, 500]"
						:key="elementui_page_component_key"
						:current-page="currentpage"
						:page-size="pagenum"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalcount"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			daorudiag: false,
			daorutitle: ['选择文件'],
			mbdialog: false,
			page: 1,
			upfilename: '',
			filestate: '',
			upfile: '',
			pagenum: 10,
			totalcount: 0,
			tableData: [],
			tableDatatan: [{}, {}, {}, {}],
			headtitle: ['发票管理', '文件导入'],
			mbtitle: ['选择模板'],
			serchval: '',
			radionochoose: '',
			changerow: '',
			id: -1,
			showstate: false,
			tableHeight: '',
			currentpage: 1,
			elementui_page_component_key: '',
			importErrorLogContent: '', //  导入错误信息
			dialogvisibleview: false
		};
	},
	created() {
		this.getImportTaskList();
	},
	mounted() {
		this.$nextTick(() => {
			this.tableHeight = this.diagheight();
			this.$refs.multipleTable.doLayout();
			window.onresize = () => {
				this.tableHeight = this.diagheight();
				this.$refs.multipleTable.doLayout();
			};
		});
	},
	methods: {
		forsech() {
			this.currentpage = 1;
			this.elementui_page_component_key++;
			this.page = 1;
			this.getImportTaskList();
		},
		showup(e) {
			this.showstate = e;
		},
		forfile(row) {
			if (row.zhuangt != 3) {
				return false;
			}
			this.downloadLog(row.kaissj, row.id);
		},
		forrest() {
			this.page = 1;
			(this.pagenum = 10), (this.serchval = '');
			this.getImportTaskList();
		},
		forchoose() {
			if (!this.changerow.id) {
				this.$message.error('请先选择模板');
				return false;
			}
			this.id = this.changerow.id;
			this.daorudiag = true;
		},
		radiochangenochoose(row, event, column) {
			this.changerow = row;
		},
		uploadFile($event) {
			this.upfilename = $event.target.files[0].name;
			var reader = new FileReader();
			let fileData = $event.target.files[0];
			console.log(fileData);
			let formData = new FormData();

			formData.append('id', this.id);

			formData.append('uploadFile', fileData);
			this.upfile = formData;
		},
		release() {
			this.upfilename = '';
			this.filestate = null;
			this.upfile = '';
			this.radionochoose = '';
			this.changerow = '';
			this.id = -1;
		},
		sureupload() {
			this.uploadExcel(this.upfile);
		},

		handleCommand(e) {
			this.release();
			if (e == 2) {
				this.getImportTemplate();
			} else if (e == 0) {
				this.daorudiag = true;
			} else if (e == 1) {
				this.daorudiag = true;
				this.id = 0;
			}
		},
		handleDownloadCommand(e) {
			location.href = this.$https.baseURL + 'template/downloadDefaultTemplate?type=' + e;
		},
		fordaoru() {
			this.getImportTemplate();
		},
		handleSizeChange(val) {
			this.pagenum = val;
			this.getImportTaskList();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getImportTaskList();
		},
		// forupload() {
		//   this.downloadDefaultTemplate();
		// },
		/* 接口调用操作 */
		// downloadDefaultTemplate() {
		//   location.href = this.$https.baseURL + 'template/downloadDefaultTemplate';
		// },
		downloadLog(startTime, id) {
			// location.href = this.$https.baseURL + 'import/downloadLog?startTime=' + startTime + '&id=' + id;
			let fileUrl = this.$https.baseURL + 'import/downloadLog?startTime=' + startTime + '&id=' + id;
			let xhr = new XMLHttpRequest();
			xhr.open('get', fileUrl, true);
			let self = this;
			this.loading = true;
			xhr.onload = function() {
				if (this.status == 200) {
					self.loading = false;
					self.importErrorLogContent = this.response;
					self.dialogvisibleview = true;
					console.log('import log：' + this.response);
				} else {
					self.loading = false;
				}
			};
			xhr.send();
		},
		/* 列表 */
		getImportTaskList() {
			let params = {
				page: this.page,
				limit: this.pagenum,
				likeSearch: this.serchval
			};
			this.$https.fetchPost('import/getImportTaskList', params).then(res => {
				this.tableData = res.data.data;
				this.totalcount = res.data.count;
			});
		},
		/* 列表 */
		getImportTemplate() {
			let params = { type: '1' };
			this.$https.fetchPost('import/getImportTemplate', params).then(res => {
				if (res.data.success) {
					this.mbdialog = true;
					this.tableDatatan = res.data.data;
					console.log(res);
				}
			});
		},

		/* 上传标准模板 */
		uploadExcel(upfile) {
			console.log(upfile);
			let params = upfile;
			this.$https.fetchPost('import/uploadExcel', params).then(res => {
				if (res.data.success) {
					this.getImportTaskList();
					this.daorudiag = false;
					this.mbdialog = false;
				}
			});
		}
	}
};
</script>

<style scoped="scoped" lang="less">
/deep/ .el-radio__label {
	display: none;
}

.sendinput {
	visibility: hidden;
}

.bt1 {
	width: 80px;
	height: 31px;
	border: 1px solid #e5e5e5;
	border-radius: 3px;
	font-size: 14px;
	cursor: pointer;
	font-weight: 500;
	color: #2f66fc;
}

// /deep/ .el-dialog__body {
// 	padding: 0;
// }

/deep/ .el-table--small td {
	padding: 4px 0;
}

/deep/ .el-table__body-wrapper {
	min-height: 160px;
}

.areatable {
	margin-top: 16px;
}

.areacontent {
	margin-left: 21px;
}
</style>
